import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/', // 首页
    name: 'Home',
    component: () => import('../views/merchant/Index.vue')
  },
  {
    path: '/merchant', // 商户页面注册（基础）
    name: 'MerchantHome',
    component: () => import('../views/merchant/Index.vue')
  },
  {
    path: '/register-success', // 商户页面注册成功（基础）
    name: 'RegisterSuccess',
    component: () => import('../views/merchant/RegisterSuccess.vue')
  },
  {
    path: '/merchant/validate', // 商户功能验证
    name: 'MerchantValidate',
    component: () => import('../views/merchant/Validate.vue')
  },
  {
    path: '/merchant/activity', // 商户活动页面（通用）
    name: 'MerchantActivity',
    component: () => import('../views/merchant/merchant-activity/Index.vue')
  },
  {
    path: '/merchant/new-success', // 商户活动注册成功页面（通用）
    name: 'NewRegisterSuccess',
    component: () => import('../views/merchant/merchant-activity/RegisterSuccess.vue')
  },
  {
    path: '/merchant/new-activity', // 新商户活动页面（部分通用）
    name: 'MerchantNewActivity',
    component: () => import('../views/merchant/merchant-activity-new/Index.vue')
  },
  {
    path: '/merchant/new-activity/success', // 新商户活动注册成功页面（部分通用）
    name: 'ActivityRegisterSuccess',
    component: () => import('../views/merchant/merchant-activity-new/RegisterSuccess.vue')
  },
  {
    path: '/merchant/activity/save-money', // 省钱活动（临时）
    name: 'MerchantActivitySaveMoney',
    component: () => import('../views/merchant/activity/SaveMoney.vue')
  },
  {
    path: '/merchant/activity/to-alipay', // 用于第三方APP跳转支付宝小程序
    name: 'AppToAlipay',
    component: () => import('../views/merchant/activity/AppToAlipay.vue')
  },
  {
    path: '/merchant/activity/common', // 通用活动页面(根据后台配置渲染)
    name: 'CommonActivity',
    component: () => import('../views/merchant/activity/Common.vue')
  },
  {
    path: '/service', // 在线客服
    name: 'Service',
    component: () => import('../views/Service.vue')
  },
  {
    path: '/thirdPay', // 第三方支付
    name: 'ThirdPay',
    component: () => import('../views/ThirdPay.vue')
  },
  {
    path: '/thirdPaySuc', // 第三方支付回调成功
    name: 'ThirdPaySuc',
    component: () => import('../views/ThirdPaySuc.vue')
  },
  {
    path: '/privacy-agreement',
    name: 'PrivacyAgreement',
    component: () => import('../views/PrivacyAgreement.vue')
  },
  {
    path: '/qiaoji/privacy-agreement', // 俏机用户隐私协议
    name: 'QiaoJiPrivacyAgreement',
    component: () => import('../views/app/qiaoji/PrivacyAgreement.vue')
  },
  {
    path: '/qiaoji/register-agreement', // 俏机用户注册协议
    name: 'QiaoJiRegisterAgreement',
    component: () => import('../views/app/qiaoji/RegisterAgreement.vue')
  },
  {
    path: '/qzj/user-privacy', // 俏租机用户隐私协议
    name: 'QiaoZuJiPrivacyAgreement',
    component: () => import('../views/agreements/qzj/UserPrivacy.vue')
  },
  {
    path: '/qzj/register-privacy', // 俏租机用户注册协议
    name: 'QiaoZuJiRegisterPrivacy',
    component: () => import('../views/agreements/qzj/RegisterPrivacy.vue')
  },
  {
    path: '/app/landing-page', // 临时使用，后面会废弃
    name: 'AppLandingPage',
    component: () => import('../views/app/LandingPage.vue')
  },
  {
    path: '/app/download', // 通用下载页面
    name: 'AppDownload',
    component: () => import('../views/app/Download.vue')
  },
  {
    path: '/app/user-info-callback', // 用户信息回调
    name: 'UserInfoCallBack',
    component: () => import('../views/app/UserInfoCallBack.vue')
  },
  {
    path: '/qhs/recovery-terms',
    name: 'RecoveryTerms',
    component: () => import('../views/agreements/qhs/RecoveryTerms.vue')
  },
  {
    path: '/qhs/user-privacy',
    name: 'UserPrivacy',
    component: () => import('../views/agreements/qhs/UserPrivacy.vue')
  },
  {
    path: '/tiktok/index',
    name: 'TiktokIndex',
    component: () => import('../views/tiktok/index.vue')
  },
  {
    path: '/tiktok/pre-authorization',
    name: 'PreAuthorization',
    component: () => import('../views/tiktok/PreAuthorization.vue')
  },
  {
    path: '/jd/cancel-contract',
    name: 'JdCancelContract',
    component: () => import('../views/jd/CancelContract.vue')
  },
  {
    path: '/jd/activity',
    name: 'JdActivity',
    component: () => import('../views/jd/activity/Common.vue')
  },
  {
    path: '/jd/register-agreement',
    name: 'JdRegisterAgreement',
    component: () => import('../views/jd/agreements/Register.vue')
  },
  {
    path: '/jd/privacy-agreement',
    name: 'JdPrivacyAgreement',
    component: () => import('../views/jd/agreements/Privacy.vue')
  },
  {
    path: '/jd/order-list',
    name: 'OpenJdOrderList',
    component: () => import('../views/jd/OrderList.vue')
  },
  {
    path: '/jd/face-success',
    name: 'JdFaceSuccess',
    component: () => import('../views/jd/FaceSuccess.vue')
  },
  {
    path: '/jd-finance/sign-success',
    name: 'JdFinanceSignSuccess',
    component: () => import('../views/jd-finance/SignSuccess.vue')
  },
  {
    path: '/jd-finance/payment-success',
    name: 'JdFinancePaymentSuccess',
    component: () => import('../views/jd-finance/PaymentSuccess.vue')
  },
  {
    path: '/payment', // 账单支付页面
    name: 'PaymentPage',
    component: () => import('../views/PaymentPage.vue')
  },
  {
    path: '/business', // H5招商
    name: 'Business',
    component: () => import('../views/Business.vue')
  },
  {
    path: '/settled-in', // 商家入驻
    name: 'SettledIn',
    component: () => import('../views/SettledIn.vue')
  },
  {
    path: '/preview-agreement',
    name: 'PreviewAgreement',
    component: ()=> import('../views/agreements/PreviewAgreement.vue')
  },
  {
    path: '*', // todo f 404
    name: 'Default',
    component: () => import('../views/merchant/Index.vue')
  }
];

const router = new VueRouter({
  mode: 'history',
  routes,
  // @ts-ignore
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      };
    } else {
      return { x: 0, y: 0 }; // 路由切换时，页面滚动到顶部
    }
  }
});

export default router;
